var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('h2',{staticClass:"homeTitle"},[_vm._v("\n    营业额统计\n  ")]),_c('div',{staticClass:"charBox"},[_c('div',{staticStyle:{"width":"100%","height":"320px"},attrs:{"id":"main"}}),_c('ul',{staticClass:"orderListLine turnover"},[_c('li',[_vm._v("营业额(元)")])])])])
}]

export { render, staticRenderFns }